(ns app.front.view.appeals.set-appealed-modal
  (:require [app.domain.appeals.model :as appeals-model]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.view.workspace.subs :as ws-subs]
            [core.db.entity.util :as eu]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::tribunals
  :<- [::ws-subs/authority-group]
  (fn [auth-group _]
    (->> auth-group
         :entity/_parent
         (filter (eu/is-type-fn :entity.type/appeals-tribunal)))))

(defn date-picker [{:keys [tr on-change parameters attr required?]}]
  [:div.mt-2
   [ui/date-picker {:label-text (tr [attr])
                    :fixed?     true
                    :required?  required?
                    :callback   #(on-change (assoc parameters attr %))
                    :value      (attr parameters)
                    :tr         tr}]])

(defn set-appealed-modal [{:keys      [tr on-change]
                           parameters :parameters}]
  (let [tribunals  (<sub [::tribunals])
        lang       (<sub [:language])
        parameters (if (-> tribunals count (= 1))
                     (assoc parameters :tribunal-id (-> tribunals first :db/id))
                     parameters)]
    [:div
     [ui-select/select {:values       tribunals
                        :label-text   (tr [:appeals/select-tribunal])
                        :value        (p/find-first tribunals {:db/id (:tribunal-id parameters)})
                        :val->str     #(appeals-model/appeals-tribunal-name % lang)
                        :id           "tribunal-select"
                        :allow-empty? false
                        :required     true
                        :on-change    #(on-change (assoc parameters :tribunal-id (:db/id %)))}]
     [date-picker (util/mmap {:attr      :appeals-information/date-of-appeal
                              :required? true}
                             tr on-change parameters)]
     [date-picker (util/mmap {:attr      :appeals-information/date-of-meeting
                              :required? false}
                             tr on-change parameters)]
     [date-picker (util/mmap {:attr      :appeals-information/date-of-decision
                              :required? false}
                             tr on-change parameters)]]))

(defn parameters-valid? [{:keys                     [tribunal-id]
                          :appeals-information/keys [date-of-appeal]}]
  (and tribunal-id date-of-appeal))
